import hero1 from "./1-5.webp";
import hero2 from "./2-4.png";
import hero3 from "./3-5.webp";
import hero4 from "./4-3.webp";
import hero5 from "./5-3 (1).webp";

const heroimg = [hero1, hero2, hero3, hero4, hero5];

export default heroimg;
